export default __webpack_public_path__ + "static/media/signup_banner.ed18b9ab.jpg";